module.exports = __webpack_public_path__ + "img/illustration-family.871350fa.png";